/**
 * AGC: Utility helpers for rendering rarity badges consistently.
 */

const RARITY_STYLES: Record<string, string> = {
  BRONZE: 'bg-amber-800 text-white',
  SILVER: 'bg-gray-300 text-slate-900',
  GOLD: 'bg-yellow-400 text-slate-900',
  DIAMOND: 'bg-sky-300 text-slate-900',
}

const formatTitleCase = (value: string): string =>
  value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()

export const formatRarityLabel = (rarityName?: string | null): string => {
  if (!rarityName) {
    return ''
  }
  const trimmed = rarityName.trim()
  if (!trimmed) {
    return ''
  }
  return formatTitleCase(trimmed)
}

export const getRarityBadgeClasses = (rarityName?: string | null): string | null => {
  if (!rarityName) {
    return null
  }
  const upper = rarityName.trim().toUpperCase()
  return RARITY_STYLES[upper] ?? null
}

